import { render, staticRenderFns } from "./SchoolEditView.vue?vue&type=template&id=354e1cc6&"
import script from "./SchoolEditView.vue?vue&type=script&lang=js&"
export * from "./SchoolEditView.vue?vue&type=script&lang=js&"
import style0 from "./SchoolEditView.vue?vue&type=style&index=0&id=354e1cc6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports